/*
Component to show the dropdown option to allow merchant users to choose a store for the session, will select the default if current user only has 1 store.
*/
import { React, useEffect, useState } from "react";
import { api } from "../utils/api";
import { chooseMerchantStoreId } from "../utils/merchantStoreSelection";

function readSessionUser() {
    try {
        const raw = sessionStorage.getItem("currentUser");
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : null;
    } catch (_error) {
        return null;
    }
}

function SelectMerchantStoreDD({ setCurrentMerchantStore, currentUser: currentUserProp }) {
    const [availableMerchantStores, setAvailableMerchantStore] = useState([]);
    const [storesLoaded, setStoresLoaded] = useState(false);
    const currentUser = currentUserProp || readSessionUser();

    useEffect(() => {
        let cancelled = false;

        const loadStores = async () => {
            const portal = sessionStorage.getItem("selectedPortal");
            const user = currentUserProp || readSessionUser();
            if (portal !== "Merchant" || !user?.merchantAccount || !user?._id) {
                return;
            }

            try {
                const response = await api(`v1/merchantUser/${user._id}/mystores`, "GET", null);
                if (cancelled) return;
                const stores = response?.data?.success
                    ? (response.data.data.merchantStores || []).filter((store) => store && store.active !== false)
                    : [];
                setAvailableMerchantStore(stores);
                setStoresLoaded(true);
            } catch (error) {
                console.error("API error:", error);
                if (!cancelled) {
                    setAvailableMerchantStore([]);
                    setStoresLoaded(true);
                }
            }
        };

        loadStores();
        return () => {
            cancelled = true;
        };
    }, [currentUser?._id, currentUser?.merchantAccount, currentUserProp]);

    const storedId = sessionStorage.getItem("selectedMerchantStore") || "";
    const selectedStore = chooseMerchantStoreId(availableMerchantStores, storedId, {
        loaded: storesLoaded,
    });

    useEffect(() => {
        if (!storesLoaded) return;
        const current = sessionStorage.getItem("selectedMerchantStore") || "";
        if (selectedStore) {
            if (selectedStore !== current) {
                sessionStorage.setItem("selectedMerchantStore", selectedStore);
            }
            setCurrentMerchantStore(selectedStore);
            return;
        }
        if (current) {
            sessionStorage.removeItem("selectedMerchantStore");
            setCurrentMerchantStore("");
        }
    }, [selectedStore, storesLoaded, setCurrentMerchantStore]);

    const handleMerchantStoreChange = (event) => {
        const nextStore = event.target.value;
        setCurrentMerchantStore(nextStore);
        sessionStorage.setItem("selectedMerchantStore", nextStore);
        window.dispatchEvent(new Event("merchant-store-changed"));
    };

    const availableMerchantStoresCount = availableMerchantStores?.length || 0;

    if (availableMerchantStoresCount === 1) {
        return (
            <div className="partner_select_MerchantStore_dd flex flex-column mb-4 items-center h-[60px] justify-between w-full p-2 border-b border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
                <div className="dropdown bg-blue-800 text-white block w-full px-2 py-1 rounded-lg text-gray-900 border focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 overflow-hidden text-ellipsis whitespace-nowrap">
                    <div className="truncate">{availableMerchantStores[0].name}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="partner_select_MerchantStore_dd flex flex-column mb-4 items-center h-auto min-h-[60px] justify-between w-full p-2 border-b border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
            <label className="text-xs mb-1 w-full text-center">Merchant Store</label>
            <select
                className="dropdown bg-blue-800 text-white block w-full px-2 py-1 rounded-lg text-gray-900 border focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 text-xs"
                onChange={handleMerchantStoreChange}
                value={selectedStore}
                style={{ width: "inherit", maxWidth: "100%" }}
            >
                <option disabled className="bg-blue-200 text-black" value="">
                    Switch Portal
                </option>
                {availableMerchantStores && availableMerchantStores.map((associatedMerchantStore) => (
                    <option className="bg-blue-200 text-black" key={associatedMerchantStore._id} value={associatedMerchantStore._id}>
                        {associatedMerchantStore.name}
                    </option>
                ))}
            </select>
        </div>
    );
}
export default SelectMerchantStoreDD;
